import { Injectable } from "@angular/core";
import { DataService } from "../../core/services/data.service";
import { PrintFormDto } from "../models/request/print-form.dto";
import { NotificationService } from "../../core/services/notification.service";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { KeyValueObject } from "../models/core/KeyValueObject";

@Injectable()
export class RequestPrintFormsService extends DataService<PrintFormDto, PrintFormDto> {
    
    constructor(
        http: HttpClient,
        notificationService: NotificationService) {
        super(http, notificationService);

        this.controllerName = 'request-print-forms';
    }

    getRequestPrintForms(requestId: number): Observable<KeyValueObject[]> {
        return this.getQuery<KeyValueObject[]>(`${this.baseUrl()}/requests/${requestId}/print-forms`);
    }

    downloadRequestPrintFormFile(requestId: number, printFormId: number) {
        const downloadUrl = `${this.baseUrl()}/requests/${requestId}/print-form/${printFormId}/download`;
        return this.http.get(downloadUrl, { responseType: 'blob' });
    }
}